// extracted by mini-css-extract-plugin
export default {"root":"ContextMenu_root__fZvGM","container":"ContextMenu_container__yr+x4"};